import React from "react";
import ReactEcharts from "echarts-for-react";

function PieData(props) {
  const years = [2023, 2024, 2025, 2026];
  const maleData = [1200, 1400, 1300, 1500];
  const femaleData = [1000, 1150, 1107, 1301];

  const pieData = years.map((year, index) => ({
    value: maleData[index],
    name: `${year}级 (男)`, // 也可以写成 `${year}年`
  }));
  const pieData1 = years.map((year, index) => ({
    value: femaleData[index],
    name: `${year}级 (女)`, // 也可以写成 `${year}年`
  }));
  const getOptions = () => {
    return {
      grid: {
        left: 20, // 左边距20px
        right: 20, // 右边距20px
        bottom: 20,
        top: 60,
        containLabel: true,
      },

      series: [
        {
          name: "人数分布", // 系列名称
          type: "pie", // 图表类型：pie
          radius: "50%", // 饼图半径，'50%'表示自适应容器大小的一半
          center: ["50%", "50%"], // 饼图位置：居中
          data: pieData, // 数据源
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          // 可选：显示标签
          label: {
            formatter: "{b}: {c} ({d}%)", // 显示名称、数值、百分比
          },
          left: 0,
          right: "50%",
          top: 0,
          bottom: 0,
        },
        {
          name: "人数分布", // 系列名称
          type: "pie", // 图表类型：pie
          radius: "50%", // 饼图半径，'50%'表示自适应容器大小的一半
          center: ["50%", "50%"], // 饼图位置：居中
          data: pieData1, // 数据源
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          // 可选：显示标签
          label: {
            formatter: "{b}: {c} ({d}%)", // 显示名称、数值、百分比
          },
          left: "50%",
          right: 0,
          top: 0,
          bottom: 0,
        },
      ],
      // 图例配置：可选，展示每个类目的名称和颜色
      legend: {
        orient: "horizontal", // 垂直排列
        top: 10,
        left: 0,
        right: 0,
      },
    };
  };

  return (
    <>
      <ReactEcharts
        style={{
          minHeight: "300px",
          width: "100%",
        }}
        option={getOptions()}
      />
    </>
  );
}

export default PieData;
